import React, { useEffect } from "react";
import RydNoteDurationImage from "../widgets/RydNoteDurationImage";
import {
    MetronomeMarking,
    NoteDuration
} from "../../model/core";
import RydHeaderDialogBox from "../widgets/RydHeaderDialogBox";
import { Metronome } from "../../model/metronome";
import { useIsMetronomeMuted, useSetMuteMetronome } from "../../stores/PlaybackConfStore";


export function TapTempoButton({
    setTempoCB
}: {
    setTempoCB: (tempo: number) => void
}) {
    const lastTapRef = React.useRef<number | null>(null);

    const handleClick = () => {
        const now = Date.now();
        if (lastTapRef.current !== null) {
            const interval = now - lastTapRef.current;
            setTempoCB(Math.round(60000 / interval));
        }
        lastTapRef.current = now;
    };

    return (
        <div>
            <button onClick={handleClick}>Tap Tempo</button>
        </div>
    );
}

const mutedStyle: React.CSSProperties = {
    backgroundColor: 'var(--md-sys-color-secondary-container)',
};

export function MetronomeActivityIndicator({
    metronomeActivityObserver
}: {
    metronomeActivityObserver: Metronome.ActivityObserver
}) {
    const button = React.useRef<HTMLButtonElement>(null);
    const isMuted = useIsMetronomeMuted();
    const setMuteMetronome = useSetMuteMetronome();

    const toggle = (step) => {

        if (!button.current) return;
        button.current!.style.backgroundImage = step % 2 === 0
            ? 'radial-gradient(circle at 30% center, red 20%, transparent 21%), radial-gradient(circle at 70% center, green 20%, transparent 21%)'
            : 'radial-gradient(circle at 30% center, green 20%, transparent 21%), radial-gradient(circle at 70% center, red 20%, transparent 21%)';
    };

    React.useEffect(() => {
        const id = metronomeActivityObserver.listen((step) => toggle(step));
        return () => {
            metronomeActivityObserver.drop(id);
        };
    }, [metronomeActivityObserver]);

    const style = {
        ...(isMuted ? mutedStyle : {}),
        backgroundImage: 'radial-gradient(circle at 30% center, red 20%, transparent 21%), radial-gradient(circle at 70% center, green 20%, transparent 21%)',
        backgroundRepeat: 'no-repeat'
    };

    return (
        <button
            ref={button}
            style={style}
            onClick={() => setMuteMetronome(!isMuted)}
        >&nbsp;</button>
    );
}

export function MetronomeInputBox({
    metronome = new MetronomeMarking(120, NoteDuration.fromBackendValue('QUARTER')),
    setMetronomeCB,
}: {
    metronome?: MetronomeMarking,
    setMetronomeCB?: (metronome: MetronomeMarking) => void,
}) {
    const [collapsed, setCollapsed] = React.useState(true);
    // FIXME: note duration hjere fixed at a quarter note and useing NoteDuration which
    // should not be used to represente a named note duration.
    const [beatDuration, setBeatDuration] = React.useState(new NoteDuration(16));

    if (collapsed) {
        return (<button
            onClick={() => setCollapsed(false)}
            >{metronome.bpm} bpm</button>);
    }

    const update = (bpm) => setMetronomeCB?.(new MetronomeMarking(bpm, beatDuration));

    return (<RydHeaderDialogBox closeCB={() => setCollapsed(true)}>
        <>
            <TapTempoButton setTempoCB={update} />
            <RydNoteDurationImage duration={beatDuration} /> =
            <input
                type="number"
                min="1"
                max="420"
                value={metronome.bpm}
                onChange={(e) => update(Number(e.target.value))}
            />bpm
        </>
    </RydHeaderDialogBox>);
}
